import React, {useEffect} from 'react';
import {MainTop} from "../../groups/group-container/main-top/Main-top";
import {ProfileBox} from "./profile-box/Profile-box";
import {ProfileInfo} from "./profile-info/Profile-info";
import AuthWrapper from "../../../auth-wrapper/AuthWrapper";
import {fetchProfileData} from "entities/Profile/model/fetchProfileDate/fetchProfileDate";
import {useAppDispatch} from "common/hook";


export const PersonalProfile = () => {
    const dispatch = useAppDispatch()

    useEffect(() => {
        dispatch(fetchProfileData())
    }, [])


    return (
        <AuthWrapper>
            <div className="app-main">
                <MainTop title={'Личный профиль'} tabs={false} setting={false} link={'/'}/>
                <ProfileBox/>
                <ProfileInfo/>
            </div>
        </AuthWrapper>
    );
};

